
<div class="topo">
  <div class="jumbotron text-center" wmAnimate="fadeInRight" speed="faster">
  </div>
  <div class="title" wmAnimate="fadeInUp" speed="fast">
    <h1 i18n="Title Header|Title for my role@@myTitle">Web & Product<br/>Developer</h1>
    <p>- Airton Toyansk -</p>
  </div>
</div>

<section id="portfolio" class="text-center bg-grey">
  <div class="header-title">
    <h1 i18n="Works Title|Title for portfolio@@myPortfolio">Featured Works</h1>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 25 1440 200">
      <path fill="#f6f6f6" fill-opacity="1" d="M0,128L80,122.7C160,117,320,107,480,122.7C640,139,800,181,960,181.3C1120,181,1280,139,1360,117.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
    </svg>
  </div>

  
  <h4 i18n="Works Intro|Intro for portfolio@@myPortIntro">A showcase of development, management and experiments I have worked on.</h4>
  <div class="contents" *ngIf="valor > 450">
    <ul id="filters" class="clearfix">
      <li><span class="filter" (click)="selectedCategory = 'all'" i18n="Works Filter|Main filter for portfolio@@myPortFilter">All Projects</span></li>
      <li *ngFor="let proj of projects | uniqueCategory:'category'" (click)="selectedCategory = proj.category"><span class="filter" >{{proj.category}}</span></li>
    </ul>
    <div id="projectlist" [@enterCard]="projects.length">

      <div class="card" *ngFor="let proj of projects | projectFilter:selectedCategory; index as i" [@filterCard]
      data-toggle="modal" [attr.data-target]="'#'+detModal" (click)="open(proj)">
        <img [src]="proj.img" class="card-img" />
        <div class="card-img-overlay">
          <div class="label">
						<div class="label-text">
							<a class="text-title">{{proj.title}}</a>
							<span class="text-category">{{proj.general}}</span>
						</div>
						<div class="label-bg"></div>
					</div>
        </div>
      </div>
      
      <div class="modal fade" [attr.id]="detModal" [ngClass]="{'show': showModal}">
        <div class="modal-dialog">
          <div class="modal-content">
      
            <!-- Modal Header -->
            <div class="modal-header">  
              <button type="button" class="close" (click)="showModal=false" data-dismiss="modal">&times;</button>
            </div>
      
            <!-- Modal body -->
            <div class="modal-body">
              <div class="entry-slide row">
                <div class="col-md-6 col-sm-12">
                  <h2>{{modalTitle}}</h2>
                  <div [innerHTML]="modalIntro"></div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <img [src]="modalImgintro"/>
                </div>
              </div>
              <div class="container-challenge">
                <div class="container-slide">
                  <ng-image-slider [images]="modalSlide" [imageSize]="modalImgsize" [imagePopup]="false" [slideImage]="1" #nav></ng-image-slider>
                </div>
                <div class="challenge">
                  <h4 i18n="Modal Title Project|Title for describing the project@@theProject">The Project</h4>
                  <div [innerHTML]="modalChallenge"></div>
                </div>
              </div>
              <div class="container-features">
                <div class="features">
                  <h4 i18n="Modal Features|Title for describing features@@theFeatures">Developed Features</h4>
                  <div class="row">
                    <div class="col-md-8 col-sm-12">
                      <div [innerHTML]="modalFeatures"></div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                      <img [src]="modalImgFet"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-tech">
                <div class="tech">
                  <h4 i18n="Modal Technologies|Title for describing Technologies@@theTechnologies">Technologies</h4>
                  <div [innerHTML]="modalTech"></div>
                </div>
              </div>
              <div class="container-access">
                <div class="access">
                  <h4 i18n="Modal for Look|Title inviting to take a look@@takeLook">Take a Look</h4>
                  <div>{{texto}}</div>
                  <a [href]="link" target="_blank">                      
                      <div *ngIf="badge === 'google'">
                        <img src="../../../assets/images/google-play-badge.png"/>
                      </div>
                      <div *ngIf="badge === 'ios'">
                        <img src="../../../assets/images/apple-badge.png"/>
                      </div>
                      <div *ngIf="badge === 'web'">
                        <img src="../../../assets/images/web.png"/>
                      </div>
                      <div *ngIf="badge === 'github'">
                        <img src="../../../assets/images/github-badge.png"/>
                      </div>
                  </a>
                </div>
              </div>
            </div>
      
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="showModal=false" data-dismiss="modal" i18n="Close Button|Label to close button@@Close">Close</button>
            </div>
      
          </div>
        </div>
      </div>

    </div>
  </div>
</section>